import comp from "./ManageAccessForSnP";
export default comp;
